import { makeStyles, Theme, createStyles } from '@material-ui/core';
import { FC } from 'react';

import { ImageControlDefinition } from '../services/layout';

import { FormControlProps } from "../utils";
import React from 'react';

export interface ImageProps extends FormControlProps<ImageControlDefinition> {
}

const useStyles = makeStyles(function (theme: Theme) {
  return createStyles({
    root: function(props: ImageProps) {
      const styles: {[key: string]: string} = props.definition?.style ?? {};
      
      return styles;
    },
  });
});

export const Image: FC<ImageProps> = function (props: ImageProps) {
  const classes = useStyles(props);
 
  return <img src={'/eval/images/prefetch/' + props.definition.src} className = { classes.root } />;
};
